<div class="wrapper">
  <span>{{ 'DIALOGS.CHECK_DEVICE_STATUS.INFO_TEXT' | translate }}</span>

  <table>
    <tr>
      <td colspan="2">
        <div class="row">
          <div class="label">{{ 'DIALOGS.CHECK_DEVICE_STATUS.GSM_GPS_STATUS' | translate }}</div>
          @if (trackerData) {
          <div class="value" [ngClass]="trackerData.coordinates?.length ? 'green' : 'yellow'">
            {{ (trackerData.coordinates?.length ? 'DIALOGS.CHECK_DEVICE_STATUS.GPS_ON' : "DIALOGS.CHECK_DEVICE_STATUS.GPS OFF") | translate
            }}
          </div>
          }
        </div>
      </td>
    </tr>
    <tr>
      <td colspan="2">
        <div class="row">
          <div class="label">{{ 'DIALOGS.CHECK_DEVICE_STATUS.SUPPLY_VOLTAGE' | translate }}</div>
          @if (isInteger(trackerData?.status?.externalVoltage)) {
          <div class="value" [ngClass]="trackerData.status.externalVoltage ? 'green' : 'yellow'">
            {{ 'ABBREVIATIONS.V' | translate: { value: (trackerData.status.externalVoltage | voltage) || 0 } }}
          </div>
          }
        </div>
      </td>
    </tr>
    <tr>
      <td colspan="2">
        <div class="row">
          <div class="label">{{ 'DIALOGS.CHECK_DEVICE_STATUS.IGNITION_STATUS' | translate }}</div>
          @if (isInteger(trackerData?.status?.ignition)) {
          <div class="value" [ngClass]="trackerData.status.ignition ? 'green' : 'yellow'">
            {{ (trackerData.status.ignition ? 'FIELDS.on' : 'FIELDS.off') | translate | uppercase }}
          </div>
          }
        </div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="label">{{ 'CLIENT.MAP.TEMPERATURE' | translate }}</div>
      </td>
      <td class="temperature">
        @if (isNumber(trackerData?.status?.temperature?.[0])) { {{ isRealtimeV3 ? trackerData.status.temperature[0] :
        trackerData.status.temperature[0] / 1000 }}&#176; }
      </td>
    </tr>
    <tr>
      <td>
        <div class="label">{{ 'DIALOGS.CHECK_DEVICE_STATUS.CURRENT_ODOMETER' | translate }}</div>
      </td>
      <td class="odometer">
        {{ 'ABBREVIATIONS.KM' | translate: { value: (trackerData?.status?.odometer || '0' | distance | number: '1.1-1') } }}
      </td>
    </tr>
  </table>

  <button [mat-dialog-close]="true" color="accent" mat-raised-button>{{ 'BUTTONS.OK' | translate}}</button>
</div>
